import React, { useEffect, useRef, useState } from "react";
import styles from "./Menu.module.css";
import ProjectionItem from "./ProjectionItem";
import EarlyWarningItem from "./EarlyWarningItem";
import SatelliteImageryItem from "./SatelliteImageryItem";
import ShowEarlyWarning from "../../mainLayer/earlyWarning/ShowEarlyWarning";
import { useSatelightContext } from "../../provider/SatelightProvider";

export interface SateliteData {
  meta_device_id: string;
  name: string;
}

type MenuItemPropType = {
  id: string;
  title: string;
};

type MenuTabPropsType = {
  id: number;
  title: string;
  type: string;
  itemDetails: Array<MenuItemPropType>;
  popupLayerType: string;
  setOpenTab: (id: number) => void;
  openTabId: number | null;
  timeLineHour: string;
  timeLineDate: string;
};

const MenuTab = ({
  id,
  title,
  type,
  itemDetails,
  popupLayerType,
  setOpenTab,
  openTabId,
  timeLineHour,
  timeLineDate
}: MenuTabPropsType) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(true);
  const [itemList, setItemList] =
    useState<Array<MenuItemPropType>>(itemDetails);
  const isUserToggled = useRef<boolean>(false);
  const { satelightListMapAdd, satelightListMap,satelightListOpen } = useSatelightContext();
  const [satelightList, setSatelightList] = useState<SateliteData[]>([]);

  useEffect(() => {
    setIsMenuOpen(popupLayerType === title);
    if (popupLayerType === title) {
      setOpenTab(id);
    }
  }, [popupLayerType, title]);

  useEffect(() => {
    if (openTabId !== id) {
      setIsMenuOpen(false);
    }
  }, [openTabId]);

  const TabToggleSwitch = () => {
    setIsMenuOpen((prevState) => !prevState);
    setOpenTab(id);
    // isUserToggled.current = true;
  };

  useEffect(() => {}, [isMenuOpen]);

  const dragItem = useRef<number>(0);
  const dragOver = useRef<number>(0);

  const handleSort = () => {
    const layerList = [...itemList];
    const temp = layerList[dragItem.current];
    layerList[dragItem.current] = layerList[dragOver.current];
    layerList[dragOver.current] = temp;
    setItemList(layerList);
  };

  useEffect(() => {
    setIsMenuOpen(popupLayerType === title);
    if (popupLayerType === title) {
      setOpenTab(id);
    }
  }, [popupLayerType, title]);

  useEffect(() => {
    fetchData();
  }, []);



  const fetchData = async () => {
 
    try {
      const response = await fetch(
        "https://mobile.mobilise-project.org.uk/mobisense/air/sensors/getreadings"
      );
      const responseData = await response.json();

      if (Array.isArray(responseData)) {
        const data: SateliteData[] = responseData;
        setSatelightList(data);
        data.forEach((satelite) => {
          satelightListMapAdd(satelite.meta_device_id, satelite.name);
          satelightListOpen(satelite.meta_device_id, false);
        });
      } else {
        console.error("Invalid response data format:", responseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // useEffect(() => {
  //   console.log("Updated satelightListMap:", satelightListMap);
  // }, [satelightListMap.entries]);



  return (
    <div key={id} className={styles.menuTabContainer}>
      <div
        className={styles.titleContainer}
        onClick={TabToggleSwitch}
        onTouchStart={TabToggleSwitch}
        style={{
          backgroundColor: `${
            isMenuOpen ? "var(--menu-tab-open-color)" : "var(--menu-main-color)"
          }`,
        }}
      >
        <img
          src={
            isMenuOpen
              ? require("../../assets/drop.png")
              : require("../../assets/up.png")
          }
          alt=""
        />
        <span>{title}</span>
      </div>
      <div
        className={styles.contentContainer}
        style={{
          height: `${isMenuOpen ? "110px" : "0.4px"}`,
          flexDirection: `${
            type === "basecamp" || type === "projection" ? "row" : "column"
          }`,
          justifyContent: `${
            type === "basecamp" || type === "projection" ? "center" : ""
          }`,
          padding: `${
            (type === "basecamp" || type === "projection") && isMenuOpen
              ? "10px"
              : "0"
          }`,
        }}
      >
        <div className={`satelliteContainer`}>
          {type === "basecamp" &&
            Array.from(satelightListMap.entries()).slice(0, 6).map(([id, name]) => (
              <SatelliteImageryItem key={id} id={id} title={name} 
              timeLineHour={timeLineHour}
              timeLineDate={timeLineDate}/>
            ))
            }
      
        </div>
        {type === "projection" &&
          itemDetails?.map((item) => (
            <ProjectionItem key={item.id} id={item.id} title={item.title} />
          ))}
      </div>
    </div>
  );
};

export default MenuTab;
